module.exports = __webpack_public_path__ + "img/logo_siemens_energy.177fba31.png";